<template>
  <div class="blocco h100 w100" v-loading="loading">

    <!-- <p>{{hotels}}</p> -->
    <h1>A quale Hotel vuoi accedere?</h1>
    <div class="spacer sm"></div>
    <div class="grid">
    <div v-for="hotel in hotels">
    <!-- <a :href="'/ombrelli/' + hotel._id" class="btn btn-blue">{{hotel.name}}</a> -->
    <router-link v-if="hotel.beachtype === 'grid'" :to="{path: '/ombrelli/' + hotel._id }" class="btn btn-green block left"><i class="fas fa-th"></i> {{hotel.name}}</router-link>
    <router-link v-if="hotel.beachtype === 'canvas'" :to="{path: '/Canvas/' + hotel._id }" class="btn btn-green block left"><i class="fas fa-umbrella-beach"></i> {{hotel.name}}</router-link>
    </div>
    <div class="spacer sm"></div>
    <router-link :to="{path: '/addhotel' }" class="btn btn-blue block left"><i class="fas fa-plus-square"></i> aggiungi Hotel</router-link>
    </div>

  </div>
</template>

<script>
  var host = process.env.ROOT_API
  export default {
    name: 'ombrelli',
    props: ['auth', 'authenticated', 'hotel'],
    data () {
      return {
        hotels: '',
        loading: true
      }
    },
    methods: {
      getHotel () {
        // console.log('hotelid: ' + this.hotelid)
        // console.log(localStorage)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
          .get(host + '/ombrelloni',
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            this.hotels = data.body.hotels
            console.log(data)
            this.loading = false
          }, (error) => {
            console.log(error)
          })
      }
    },
    beforeMount () {
      this.getHotel()
    }
  }
</script>

<style>
  a {
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// Hotel.vue?e4193aa6